const styles = {
  picker: {
    width: "93% !important",
    marginTop: "2rem",
  },
  addColor: {
    width: "100%",
    padding: "1 rem",
    marginTop: "1rem",
    fontSize: "2 rem",
  },
  colorNameInput: {
    width: "100%",
    height: "70px",
  },
};
export default styles;
